'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WSGS$]');

var winresServiceGroupSelectPricesController = function () {
    function winresServiceGroupSelectPricesController($scope) {
        _classCallCheck(this, winresServiceGroupSelectPricesController);

        this.$scope = $scope;
    }

    _createClass(winresServiceGroupSelectPricesController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.values = {};

            this.ngModelCtrl.$render = function () {
                return _this.render(_this.ngModelCtrl.$viewValue);
            };
            this.ngModelCtrl.$isEmpty = function (value) {
                return _totalAmount(_this.services, value) === 0;
            };

            this.ngModelCtrl.$validators.capacity = function (modelValue, viewValue) {
                return _this.capacity === undefined || _totalAmount(_this.services, modelValue) <= _this.capacity;
            };

            this.ngModelCtrl.$validators.min = function (modelValue, viewValue) {
                return _this.min === undefined || _totalAmount(_this.services, modelValue) >= _this.realMin();
            };

            this.ngModelCtrl.$validators.max = function (modelValue, viewValue) {
                return _this.max === undefined || _totalAmount(_this.services, modelValue) <= _this.max;
            };

            this.$scope.$watchCollection(function () {
                return _this.services;
            }, function () {
                return _this.update();
            });
        }
    }, {
        key: 'setErrorState',
        value: function setErrorState() {
            this.values = {};
            this.read();
        }
    }, {
        key: 'update',
        value: function update() {
            var _this2 = this;

            // log('Update:', this.services);

            if (!_.isArrayLike(this.services)) {
                // Invalid service list, remove all selections
                log.warn('Invalid service list:', this.services);
                this.setErrorState();
                return;
            }

            // IDs of old and new services
            var oldSIDs = _.keys(this.values);
            var sids = this.serviceIDs();

            // IDs of added and removed services
            var addedSIDs = _.difference(sids, oldSIDs);
            var removedSIDs = _.difference(oldSIDs, sids);

            if (addedSIDs.length > 0) {
                // log('Added', addedSIDs.length, 'services:', addedSIDs);
            }
            if (removedSIDs.length > 0) {
                log('Removed', removedSIDs.length, 'services:', removedSIDs);
            }

            // Add records for added services
            _.forEach(addedSIDs, function (sid) {
                _this2.values[sid] = {};
            });

            // Add records of removed services
            _.forEach(removedSIDs, function (sid) {
                _this2.values[sid] = {};
            });

            // If services were removed, some currenct selections
            // may no longer be valid. That will affect the output.
            // In that case, the output needs to be regenerated.
            if (removedSIDs.length > 0) {
                this.read();
            }
        }
    }, {
        key: 'render',
        value: function render(value) {
            // log('Input:', value);

            if (!_.isObject(value)) {
                if (value !== undefined) {
                    log.warning('Provided model value is invalid:', value);
                }
                value = {};
            }

            this.values = _.cloneDeep(value);
        }
    }, {
        key: 'read',
        value: function read(serviceID) {
            var _this3 = this;

            // If we're in radio mode, toggle all others off
            if (this.isSingle()) {
                _.forEach(this.services, function (service) {
                    if (service.id != serviceID) {
                        _this3.values[service.id] = {};
                    }
                });
            }

            var value = _.cloneDeep(this.values);
            // log('Output:', value);
            this.ngModelCtrl.$setViewValue(value);
        }
    }, {
        key: 'serviceIDs',
        value: function serviceIDs() {
            return _.map(this.services, function (s) {
                return _.toString(s.id);
            });
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled() {
            return this.disabled !== undefined && this.disabled !== false;
        }
    }, {
        key: 'isRequired',
        value: function isRequired() {
            return this.required !== undefined && this.required !== false;
        }
    }, {
        key: 'isSingle',
        value: function isSingle() {
            return this.realMin() == 1 && this.max == 1;
        }
    }, {
        key: 'realMin',
        value: function realMin() {
            if (this.min > 0) {
                return this.min;
            } else if (this.isRequired()) {
                return 1;
            } else {
                return 0;
            }
        }

        // Return the effective max for this service.
        // Since the max value applies to the total amount selected
        // from all services, this needs to be reduced if other
        // services have already been selected.

    }, {
        key: 'effectiveMax',
        value: function effectiveMax(serviceID) {
            if (this.max > 0) {
                var total = this.totalAmount();
                var ownAmounts = this.values && this.values[serviceID] || {};
                var ownTotal = _.sum(_.toArray(ownAmounts));
                var othersTotal = total - ownTotal;
                var left = this.max - othersTotal;
                return Math.max(0, left);
            } else {
                // No limit
                return undefined;
            }
        }

        // The common part of the above functions.

    }, {
        key: 'effective',
        value: function effective(maxOrCapacity, itemID) {}
    }, {
        key: 'showTotals',
        value: function showTotals() {
            return this.max === undefined || this.max > 1;
        }
    }, {
        key: 'totalAmount',
        value: function totalAmount() {
            return _totalAmount(this.services, this.values);
        }
    }, {
        key: 'totalPrice',
        value: function totalPrice() {
            var _this4 = this;

            return _.sumBy(this.services, function (service) {
                var amounts = _this4.values && _this4.values[service.id] || {};
                return _.sumBy(service.prices, function (price) {
                    var amount = amounts[price.id] || 0;
                    return amount * price.price;
                });
            });
        }
    }]);

    return winresServiceGroupSelectPricesController;
}();

function _totalAmount(services, values) {
    return _.sumBy(services, function (service) {
        var amounts = values && values[service.id] || {};
        return _.sum(_.toArray(amounts));
    });
}

winresServiceGroupSelectPricesController.$inject = ['$scope'];

_module3.default.component('winresServiceGroupSelectPrices', {
    template: require('./winresServiceGroupSelectPrices.html'),
    controller: winresServiceGroupSelectPricesController,
    require: {
        ngModelCtrl: 'ngModel'
    },
    bindings: {
        // List of services and their prices. NOTE: The id fields are meant
        // to be unique to each service and price. They are used to detect when
        // a service or a price is added or removed, so that the corresponding
        // selections can also be removed.
        // [
        //     {
        //         id: 'STH-ZOO'
        //         name: 'Stockholm Zoo',
        //         capacity: 99,
        //         prices: [
        //             { id: '1', name: 'Adult', price: 25 },
        //             { id: '2', name: 'Child (2-12)', price: 12.5 }
        //         ]
        //     },
        //     {
        //         id: 'STH-MUS',
        //         name: 'Stockholm Museum',
        //         capacity: 99,
        //         prices: {
        //             { id: '1', name: 'Adult', price: 10 },
        //             { id: '2', name: 'Child (0-17)', price: 5 }
        //             { id: '3', name: 'Senior (>65)', price: 5 },
        //         }
        //     }
        // ]
        services: '<',

        // An object of selected service price amounts.
        // {
        //     'STH-ZOO': {
        //         '1': 2,
        //         '2': 1
        //     },
        //     'STH-MUS': {
        //         '1': 1,
        //         '2': 1,
        //         '3': 1
        //     }
        // }
        ngModel: '<',

        // If this attribute is set (to anything), the component is disabled.
        disabled: '@',

        // If this attribute is set (to anything), a non-empty value is required.
        required: '@',

        // At least this many items must be selected.
        min: '<',

        // At most this many items may be selected.
        max: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServiceGroupSelectPrices/winresServiceGroupSelectPrices.js
// module id = 461
// module chunks = 2